const baseSettings = {
    booleanFields: [
        'isActive',
        'exchangeProducts',
        'exchangePrices',
        'exchangeOrders',
        'exchangeStocks',
        'transferIndividualStock',
        'onlyCatalogStock',
        'transferZeroBalances',
        'updatePriceBusiness',
        'useYandexOrderId'
    ],
    selectFields: [
        {
            name: 'priceTypeDiscount',
            option: 'prices'
        },
        {
            name: 'priceType',
            option: 'prices'
        },
        {
            name: 'orderMethod',
            option: 'orderMethods'
        },
        {
            name: 'orderType',
            option: 'orderTypes'
        },
        {
            name: 'paymentPaidStatus',
            option: 'paymentStatuses'
        },
        {
            name: 'acceptanceFieldCode',
            option: 'externalFields'
        },
        {
            name: 'labelFormat',
            option: 'labelFormatOptions'
        },
        {
            name: 'systemOrderIdSource',
            option: 'systemOrderIdSourceOptions'
        }
    ]
}

export { baseSettings }
